import styled from 'styled-components';

export const PersonSearchContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const SearchResults = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
`;

export const SearchResultItem = styled.div`
  padding: 12px;
  cursor: pointer;
  border-bottom: 1px solid #f7fafc;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: #f7fafc;
  }
`;

export const PersonName = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: #2d3748;
`;

export const PersonType = styled.div`
  font-size: 12px;
  color: #718096;
  margin-top: 2px;
`;

export const LoadingContainer = styled.div`
  padding: 12px;
  text-align: center;
  color: #718096;
  font-size: 14px;
`;

export const NoResultsContainer = styled.div`
  padding: 12px;
  text-align: center;
  color: #718096;
  font-size: 14px;
`;

export const SelectedPerson = styled.div`
  margin-top: 8px;
  padding: 12px;
  background: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const PersonInfo = styled.div`
  flex: 1;
`;
